<template>
  <div class="inventoryTransfer">
    <h2>调拨</h2>
    <el-form :inline="true">
      <el-form-item label="调拨日期">
        <el-date-picker v-model="searchParam.transferDates" type="daterange" start-placeholder="起" end-placeholder="止" style="width: 220px;" />
      </el-form-item>
      <el-form-item label="调出仓储">
        <el-select v-model="searchParam.outStorage" filterable style="width: 120px;" clearable>
          <el-option v-for='storageItem in show.storageList' :key="storageItem.id" :label="storageItem.value" :value="storageItem.value" />
        </el-select>
      </el-form-item>
      <el-form-item label="调入仓储">
        <el-select v-model="searchParam.inStorage" filterable style="width: 120px;" clearable>
          <el-option v-for='storageItem in show.storageList' :key="storageItem.id" :label="storageItem.value" :value="storageItem.value" />
        </el-select>
      </el-form-item>
      <el-form-item label="煤矿品名">
        <el-select v-model="searchParam.product" filterable style="width: 120px;" clearable>
          <el-option v-for='productItem in show.productList' :key="productItem.id" :label="productItem.value" :value="productItem.value" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button-group>
          <el-button type="primary" @click="commitFindList()">搜索</el-button>
          <el-button @click="resetSearchParam()">重置</el-button>
        </el-button-group>
      </el-form-item>
      <el-form-item>
        <el-button-group>
          <el-button type="primary" @click="add()">新建</el-button>
          <el-button type="warning" :disabled="!(show.selected.length == 1)" @click="update()">详情</el-button>
          <el-button type="danger" :disabled="!(show.selected.length >= 1)" @click="del()" :loading="show.saving">删除</el-button>
        </el-button-group>
      </el-form-item>
    </el-form>
    <el-table :data="data.list" @selection-change="selectionChange()" ref="tabRef" border show-summary :summary-method="summary" style="height: calc(100vh - 310px);">
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column width="55" align="center">
        <template #default="scope">
          <el-link type="primary" @click="update(scope.row)">详情</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="outStorage" label="调出仓储" width="120" show-overflow-tooltip />
      <el-table-column prop="inStorage" label="调入仓储" width="120" show-overflow-tooltip />
      <el-table-column prop="product" label="煤矿品名" width="120" show-overflow-tooltip />
      <el-table-column prop="outQuantity" label="调出数量" width="100" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.outQuantity) }}
        </template>
      </el-table-column>
      <el-table-column prop="lossQuantity" label="亏吨" width="90" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.lossQuantity) }}
        </template>
      </el-table-column>
      <el-table-column prop="inQuantity" label="调入数量" width="100" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.inQuantity) }}
        </template>
      </el-table-column>
      <el-table-column prop="outProductPrice" label="调出单价" width="100" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.outProductPrice) }}
        </template>
      </el-table-column>
      <el-table-column label="总成本" width="120" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(productAmount(scope.row)) }}
        </template>
      </el-table-column>
      <el-table-column label="调入单价" width="100" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(math.divide(productAmount(scope.row), scope.row.inQuantity)) }}
        </template>
      </el-table-column>
      <el-table-column prop="outTransportPrice" label="调出运费单价" width="120" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.outTransportPrice) }}
        </template>
      </el-table-column>
      <el-table-column prop="transferTransportPrice" label="调拨运费单价" width="120" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.transferTransportPrice) }}
        </template>
      </el-table-column>
      <el-table-column prop="transferTransportDeductionAmount" label="运费扣除" width="110" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.transferTransportDeductionAmount) }}
        </template>
      </el-table-column>
      <el-table-column prop="transferTransportAmountAfterDeduction" label="实付运费" width="110" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.transferTransportAmountAfterDeduction) }}
        </template>
      </el-table-column>
      <el-table-column prop="transferTransportServiceAmount" label="服务费" width="110" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.transferTransportServiceAmount) }}
        </template>
      </el-table-column>
      <el-table-column prop="transferTransportAmount" label="运费合计" width="110" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.transferTransportAmount) }}
        </template>
      </el-table-column>
      <el-table-column label="总运费" width="120" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(transportAmount(scope.row)) }}
        </template>
      </el-table-column>
      <el-table-column label="调入运费单价" width="120" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(math.divide(transportAmount(scope.row), scope.row.inQuantity)) }}
        </template>
      </el-table-column>
      <el-table-column prop="transferDate" label="调拨日期" width="120" show-overflow-tooltip />
      <el-table-column prop="createDatetime" label="新增时间" width="170" show-overflow-tooltip />
      <el-table-column prop="operateDatetime" label="修改时间" width="170" show-overflow-tooltip />
    </el-table>
    <div style="height: 10px;" />
    <el-pagination v-model:current-page="searchParam.pageNum" v-model:page-size="searchParam.pageSize" :page-sizes="[300, 500, 1000, 2000]" background layout="total, sizes, prev, pager, next, jumper" :total="data.total" @change="commitFindList()" />
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import api from '../../apis/api'
import cache from '../../utils/cache'
import util from '../../utils/util'
import math from '../../utils/math'


const router = useRouter()
const tabRef = ref()

const data = reactive({
  total: 0,
  list: [],
  accumulate: {},
})

const show = reactive({
  saving: false,
  selected: [],
  storageList: [],
  productList: [],
})

api.get('/backend/dict/getByCode', { params: { code: 'storage' } }).then(res => {
  show.storageList = res.dictList
})
api.get('/backend/dict/getByCode', { params: { code: 'product' } }).then(res => {
  show.productList = res.dictList
})

const searchParam = reactive({})
const resetSearchParam = () => {
  searchParam.pageNum = 1
  searchParam.pageSize = 300
  searchParam.transferDates = []
  searchParam.outStorage = null
  searchParam.inStorage = null
  searchParam.product = null
}
resetSearchParam()
const beforeSearchParam = cache.getObject(cache.keys.pageParam + 'inventoryTransfer')
if (beforeSearchParam) {
  Object.assign(searchParam, beforeSearchParam)
  cache.setObject(cache.keys.pageParam + 'inventoryTransfer', null)
}

/** 总成本 = 调出数量 * 调出单价 */
const productAmount = (row) => {
  return math.multiply(row.outQuantity, row.outProductPrice)
}

/** 总运费 = 调出数量 * 调出运费单价 + 运费合计 */
const transportAmount = (row) => {
  return math.plus(math.multiply(row.outQuantity, row.outTransportPrice), row.transferTransportAmount)
}

const commitFindList = () => {
  const params = {}
  params.pageNum = searchParam.pageNum
  params.pageSize = searchParam.pageSize
  if (searchParam.transferDates && searchParam.transferDates.length == 2) {
    params.transferDateGe = util.parseTime(searchParam.transferDates[0], '{y}-{m}-{d}')
    params.transferDateLe = util.parseTime(searchParam.transferDates[1], '{y}-{m}-{d}')
  }
  params.outStorage = searchParam.outStorage
  params.inStorage = searchParam.inStorage
  params.product = searchParam.product
  api.get('/backend/inventoryTransfer/page', { params: params }).then(res => {
    data.list = res.list
    data.total = res.total
    data.accumulate = res.data
  })
}
commitFindList()

const summary = () => {
  const a = data.accumulate
  // 总运费里已经含了运费合计，调出运费合计需要把它扣掉才是调出运费单价的分子
  const outTransportAmount = math.plus(a.transportAmount, -a.transferTransportAmount)
  // 调拨运费小计 = 实付运费 + 运费扣除，再除以调入数量还原成单价
  const transferTransportSubtotal = math.plus(a.transferTransportAmountAfterDeduction, a.transferTransportDeductionAmount)
  return [
    '合计',
    '',
    '',
    '',
    '',
    math.formatNumber(a.outQuantity),
    math.formatNumber(a.lossQuantity),
    math.formatNumber(a.inQuantity),
    math.formatNumber(math.divide(a.productAmount, a.outQuantity)),
    math.formatNumber(a.productAmount),
    math.formatNumber(math.divide(a.productAmount, a.inQuantity)),
    math.formatNumber(math.divide(outTransportAmount, a.outQuantity)),
    math.formatNumber(math.divide(transferTransportSubtotal, a.inQuantity)),
    math.formatNumber(a.transferTransportDeductionAmount),
    math.formatNumber(a.transferTransportAmountAfterDeduction),
    math.formatNumber(a.transferTransportServiceAmount),
    math.formatNumber(a.transferTransportAmount),
    math.formatNumber(a.transportAmount),
    math.formatNumber(math.divide(a.transportAmount, a.inQuantity)),
    '',
    '',
    '',
  ]
}

const selectionChange = () => {
  show.selected = tabRef.value.getSelectionRows()
}

const add = () => {
  cache.setObject(cache.keys.pageParam + 'inventoryTransfer', searchParam)
  cache.setObject(cache.keys.pageParam + 'inventoryTransferDetail', null)
  router.push('/inventoryTransferDetail')
}

const update = (row) => {
  cache.setObject(cache.keys.pageParam + 'inventoryTransfer', searchParam)
  const inventoryTransfer = row ? row : tabRef.value.getSelectionRows()[0]
  cache.setObject(cache.keys.pageParam + 'inventoryTransferDetail', inventoryTransfer)
  router.push('/inventoryTransferDetail')
}

const del = () => {
  if (show.saving) {
    return
  }
  const ids = tabRef.value.getSelectionRows().map(inventoryTransfer => inventoryTransfer.id)
  ElMessageBox.confirm('', {
    title: '确认删除',
    message: '将要删除选中的 ' + ids.length + ' 项。删除后调出仓储的库存会退回，调入仓储的库存会扣减。',
    autofocus: false,
    confirmButtonText: '确认',
    cancelButtonText: '取消'
  }).then(() => {
    show.saving = true
    api.post('/backend/inventoryTransfer/del', { ids: ids }).then(() => {
      ElMessage.success('删除成功')
      commitFindList()
    }).finally(() => {
      show.saving = false
    })
  })
}
</script>

<style lang="less"></style>
